import { render, staticRenderFns } from "./child-study-report.vue?vue&type=template&id=03976150&scoped=true&"
import script from "./child-study-report.vue?vue&type=script&lang=js&"
export * from "./child-study-report.vue?vue&type=script&lang=js&"
import style0 from "./child-study-report.vue?vue&type=style&index=0&id=03976150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03976150",
  null
  
)

export default component.exports